export const formatMoney = (amount, currency = 'USD') => {
  const value = Number(amount || 0).toFixed(2);
  return `${currency} ${value}`;
};

export const getIntervalLabel = (interval, intervalCount = 1) => {
  if (!interval) {
    return '';
  }

  if (intervalCount > 1) {
    if (interval === 'year') return `cada ${intervalCount} años`;
    if (interval === 'month') return `cada ${intervalCount} meses`;
    return `cada ${intervalCount} ${interval}`;
  }

  if (interval === 'month') return 'por mes';
  if (interval === 'year') return 'por año';
  return '';
};

export const getRecurringLabel = (interval, intervalCount = 1) => {
  if (intervalCount > 1) {
    return interval === 'year'
      ? `${intervalCount} años`
      : `${intervalCount} meses`;
  }
  return interval === 'year' ? 'año' : 'mes';
};
